import React, { useCallback } from 'react';
import { VimSDKProvider } from '@getvim/internal-vim-os-sdk/react';
import { ErrorBoundaryWrapper } from '@getvim/atomic-ui';
import { createLogger } from './utils/createLogger';
import { AnalyticsProvider } from './analytics/AnalyticsProvider';

const sdkOptions = {
  appTokenEndpoint: `${window.location.origin}/api/v2/auth/token`,
};
const GENERAL_ERROR_SUB_MESSAGE =
  'Please try again later or contact support if the problem persists.';
const logger = createLogger('AppWrapper');
export const AppWrapper: React.FC = ({ children }) => {
  const handleRenderError = useCallback(({ error }) => {
    logger.error('Client application crashed due to render error', {
      error: error.message,
      noPHI: true,
    });
    logger.error('Client application crashed due to render error', {
      error,
    });
  }, []);
  return (
    <ErrorBoundaryWrapper
      applicationDisplayName="Prior Auth"
      subMessage={GENERAL_ERROR_SUB_MESSAGE}
      onRenderError={handleRenderError}
    >
      <VimSDKProvider {...sdkOptions}>
        <AnalyticsProvider>{children}</AnalyticsProvider>
      </VimSDKProvider>
    </ErrorBoundaryWrapper>
  );
};
